export default __webpack_public_path__ + "static/media/COSM376.867ea8f6.PNG";